module.exports = require("./pluginPropEdit.vue");